/**
 * Rotas autenticadas que não recebem a superfície principal `PageSurface`.
 *
 * `/tracking` é o mapa de rastreamento: mapa, painéis e controles mantêm o
 * fundo atual. As demais rotas privadas usam o fundo `bg-secondary` (#F5F5F5).
 */
export const PAGE_SURFACE_EXCLUDED_PATHS: ReadonlySet<string> = new Set([
	"/tracking",
]);

const TRAILING_SLASHES = /\/+$/;

export function usesPageSurface(pathname: string): boolean {
	const normalized = pathname.replace(TRAILING_SLASHES, "") || "/";
	return !PAGE_SURFACE_EXCLUDED_PATHS.has(normalized);
}
